import React, { useContext } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import { Footer as SharedFooter } from '@spotify-internal/masthead-react';
import { Footer as S4XFooter } from '@spotify-internal/s4x-masthead';

import { MarketContext } from 'providers/market';
import { useVerticalConfig } from 'providers/vertical';
import { Vertical } from 'utils/vertical';
import { useMastheadData } from 'providers/MastheadProvider';
import { TurnkeyFooter } from 'components/Masthead/Footer';

export const Footer = () => {
  const { footer } = useMastheadData();

  const { locale, preferredDir } = useContext(MarketContext);
  const { verticalName, features } = useVerticalConfig();

  if (features.configureMasthead?.footer === 's4a') {
    return <S4XFooter />;
  }

  if (features.configureMasthead?.footer === 'turnkey') {
    return <TurnkeyFooter />;
  }

  if (!footer) return null;

  const topLinkGroups = cloneDeep(footer.topLinkGroups);

  // A custom Contact Us link is added for the en-US market when using the consumer vertical
  if (topLinkGroups?.length && verticalName === Vertical.CONSUMER && locale === 'en-US') {
    topLinkGroups[topLinkGroups.length - 1].links?.push({
      title: 'Contact Spotify',
      href: 'https://support.spotify.com/article/contact-us/?in_footer',
    });
  }

  return (
    <div dir={preferredDir}>
      <SharedFooter {...footer} topLinkGroups={topLinkGroups} />
    </div>
  );
};
